import React, { useState } from "react";

const questions = [
  {
    id: 1,
    text: "1. Sếp khen 'Em làm tốt lắm' nhưng nhân viên vẫn mặt lạnh tanh. Tại sao?",
    options: {
      A: "Vì sếp khen chưa đủ to.",
      B: "Vì lời khen quá chung chung, không chỉ rõ họ làm tốt ở điểm nào.",
      C: "Vì nhân viên đó đang đói."
    },
    correct: "B"
  },
  {
    id: 2,
    text: "2. Cách khen nào sau đây 'chạm' đúng tim người thích Lời Khen nhất?",
    options: {
      A: "Bà giỏi thật đấy!",
      B: "Cách bà chốt sale với ông khách khó tính hồi sáng đỉnh thật sự, khéo léo cực!",
      C: "Im lặng mỉm cười và giơ ngón cái lên."
    },
    correct: "B"
  },
  {
    id: 3,
    text: "3. Đối với người có ngôn ngữ là Lời Khen, điều gì khiến họ tổn thương nhất?",
    options: {
      A: "Sếp không rủ đi ăn trưa.",
      B: "Chỉ trích họ một cách gay gắt, hoặc làm ngơ trước nỗ lực của họ.",
      C: "Quên mua quà cho họ lúc đi công tác về."
    },
    correct: "B"
  },
  {
    id: 4,
    text: "4. 'Dành thời gian chất lượng' ở công ty có nghĩa là gì?",
    options: {
      A: "Ngồi họp với nhau suốt 8 tiếng.",
      B: "Giao tiếp trọn vẹn, cất điện thoại đi và thực sự chú ý lắng nghe họ nói.",
      C: "Cho họ về sớm trước 1 tiếng."
    },
    correct: "B"
  },
  {
    id: 5,
    text: "5. Một đồng nghiệp thích 'Thời Gian' đang muốn tâm sự vụ dự án hỏng. Bạn nên làm gì?",
    options: {
      A: "Rủ rê: 'Ra góc ban công uống cafe 10 phút nhé, mình nghe đây.'",
      B: "Chạy lại dọn bàn cho họ.",
      C: "Ném cho họ cục kẹo rồi quay lại làm việc tiếp."
    },
    correct: "A"
  },
  {
    id: 6,
    text: "6. Sai lầm lớn nhất khi giao tiếp với người thích 'Thời Gian' là gì?",
    options: {
      A: "Mắt cứ cắm vào màn hình máy tính gõ lạch cạch khi họ đang nói.",
      B: "Không khen họ.",
      C: "Không bao họ uống nước."
    },
    correct: "A"
  },
  {
    id: 7,
    text: "7. Châm ngôn sống của người thuộc nhóm 'Hành Động Giúp Đỡ' là gì?",
    options: {
      A: "Lời nói gió bay, thực hành mới nhớ.",
      B: "Tình yêu đi qua cái dạ dày.",
      C: "Lời nói chẳng mất tiền mua."
    },
    correct: "A"
  },
  {
    id: 8,
    text: "8. Thấy nhỏ ngồi cạnh (thuộc nhóm Giúp Đỡ) đang chạy deadline sấp mặt, cách ủi an tốt nhất là:",
    options: {
      A: "Vỗ vai bảo: 'Cố lên em gái, em làm được mà!'",
      B: "Mua ly trà đá để lên bàn.",
      C: "Hỏi thẳng: 'Đưa file Excel đây anh format phụ cho lẹ.'"
    },
    correct: "C"
  },
  {
    id: 9,
    text: "9. Bạn vô tình làm người nhóm 'Giúp Đỡ' cáu điên khi:",
    options: {
      A: "Bạn quên sinh nhật họ.",
      B: "Bạn hứa sẽ gửi báo cáo phụ họ nhưng lại quên béng mất, để họ tự bơi.",
      C: "Bạn không ôm họ lúc chia tay."
    },
    correct: "B"
  },
  {
    id: 10,
    text: "10. Tại nơi làm việc, 'Quà Tặng' theo chuẩn cuốn sách này mang ý nghĩa gì?",
    options: {
      A: "Phải là tiền thưởng nóng, quà đắt tiền như iPhone.",
      B: "Là vật chất thể hiện sự quan tâm: 'À, tôi có nghĩ đến bạn lúc tôi không ở công ty'.",
      C: "Là quà bắt buộc phải tặng mỗi dịp lễ."
    },
    correct: "B"
  },
  {
    id: 11,
    text: "11. Món quà nào là chuẩn bài nhất cho nhóm 'Quà Tặng' nơi công sở?",
    options: {
      A: "Vài bịch bánh tráng, kẹo cu đơ mua lúc về quê mang lên chia cho team.",
      B: "Chuyển khoản 2 triệu.",
      C: "Một cái bằng khen bằng giấy."
    },
    correct: "A"
  },
  {
    id: 12,
    text: "12. Người nhóm 'Quà Tặng' sẽ cảm thấy rất hụt hẫng khi:",
    options: {
      A: "Đi công tác xa về mà mọi người không mua nổi một gói bánh nhỏ làm quà.",
      B: "Sếp không ngồi cà phê với họ.",
      C: "Không ai phụ họ bưng bình nước."
    },
    correct: "A"
  },
  {
    id: 13,
    text: "13. Áp dụng 'Cử Chỉ/Tương tác' trong môi trường văn phòng sao cho chuyên nghiệp và không bị hiểu lầm?",
    options: {
      A: "Gặp ai cũng ôm hôn thắm thiết.",
      B: "Một cái 'high-five' (đập tay), cú đấm tay (fist bump), hoặc vỗ vai khích lệ hợp lý.",
      C: "Né tránh mọi tiếp xúc vật lý để giữ an toàn tuyệt đối."
    },
    correct: "B"
  },
  {
    id: 14,
    text: "14. Năng lượng của người thuộc nhóm 'Cử Chỉ' trong team thường như thế nào?",
    options: {
      A: "Lầm lì, ít nói.",
      B: "Rất thích không khí sôi nổi, hay tạo ra những hành động ăn mừng vật lý khi chốt đơn.",
      C: "Chỉ thích làm việc qua email."
    },
    correct: "B"
  },
  {
    id: 15,
    text: "15. Khi team vừa hoàn thành một chiến dịch khổng lồ, sếp làm gì thì người nhóm 'Cử Chỉ' sướng nhất?",
    options: {
      A: "Sếp gửi một cái email dài 2 trang.",
      B: "Sếp đưa cho voucher mua sắm.",
      C: "Sếp bước tới, bắt tay thật chặt từng người và cụng ly ăn mừng."
    },
    correct: "C"
  }
];

export default function KnowledgeAssessment() {
  const [answers, setAnswers] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [score, setScore] = useState(0);

  const handleSelect = (questionId, optionKey) => {
    if (!isSubmitted) {
      setAnswers({ ...answers, [questionId]: optionKey });
    }
  };

  const calculateScore = () => {
    if (Object.keys(answers).length < questions.length) {
      alert("Bạn ơi, làm nốt mấy câu còn thiếu để xem mình đạt mấy điểm nhé!");
      return;
    }

    let currentScore = 0;
    questions.forEach((q) => {
      if (answers[q.id] === q.correct) {
        currentScore++;
      }
    });

    setScore(currentScore);
    setIsSubmitted(true);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div style={{ maxWidth: "600px", margin: "0 auto", padding: "20px", fontFamily: "sans-serif" }}>
      <h1 style={{ textAlign: "center", color: "#333" }}>Bài Test Cấp Độ "Tinh Tế" Chốn Công Sở! 🧠</h1>
      
      {!isSubmitted ? (
        <p style={{ textAlign: "center", color: "#666", marginBottom: "30px" }}>
          Anh em đã cày xong Video và Podcast chưa? Làm nhẹ 15 câu trắc nghiệm này để xem mình đã thành "bậc thầy thả thính" đồng nghiệp chưa nhé!
        </p>
      ) : (
        <div style={{ textAlign: "center", padding: "20px", borderRadius: "8px", backgroundColor: score >= 12 ? "#d4edda" : "#fff3cd", color: score >= 12 ? "#155724" : "#856404", marginBottom: "30px", border: `2px solid ${score >= 12 ? "#c3e6cb" : "#ffeeba"}` }}>
          <h2>Điểm của bạn: {score} / 15</h2>
          <p style={{ fontSize: "18px", fontWeight: "bold" }}>
            {score === 15 ? "Đỉnh kout! Bạn chính là chuyên gia tâm lý học của phòng ban! 🏆" :
             score >= 10 ? "Khá lắm! Bạn đã nắm được bí kíp sinh tồn chốn công sở rồi đó! 🔥" :
             "Kém tinh tế quá nha! Xem lại Video và Podcast ngay cho tôi! 😅"}
          </p>
          <p style={{ fontSize: "14px" }}>Kéo xuống dưới để xem mình sai ở đâu nhé 👇</p>
        </div>
      )}

      <div>
        {questions.map((q) => (
          <div key={q.id} style={{ marginBottom: "25px", padding: "15px", border: "1px solid #ddd", borderRadius: "8px", backgroundColor: "#f9f9f9" }}>
            <p style={{ fontWeight: "bold", marginTop: "0" }}>{q.text}</p>
            <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
              {Object.entries(q.options).map(([key, text]) => {
                let labelStyle = { cursor: isSubmitted ? "default" : "pointer", display: "flex", alignItems: "center", gap: "10px", padding: "8px", borderRadius: "5px" };
                
                // Coloring logic after submission
                if (isSubmitted) {
                  if (key === q.correct) {
                    labelStyle.backgroundColor = "#d4edda"; // Highlight correct answer green
                    labelStyle.border = "1px solid #c3e6cb";
                  } else if (answers[q.id] === key && key !== q.correct) {
                    labelStyle.backgroundColor = "#f8d7da"; // Highlight wrong user pick red
                    labelStyle.border = "1px solid #f5c6cb";
                  }
                }

                return (
                  <label key={key} style={labelStyle}>
                    <input
                      type="radio"
                      name={`knowledge-${q.id}`}
                      value={key}
                      checked={answers[q.id] === key}
                      onChange={() => handleSelect(q.id, key)}
                      disabled={isSubmitted}
                      style={{ width: "20px", height: "20px" }}
                    />
                    {text}
                  </label>
                );
              })}
            </div>
            {isSubmitted && answers[q.id] !== q.correct && (
              <p style={{ color: "#d9534f", fontSize: "14px", marginTop: "10px", fontWeight: "bold" }}>
                👉 Đáp án đúng là {q.correct} nha bạn ơi!
              </p>
            )}
          </div>
        ))}

        {!isSubmitted ? (
          <button 
            onClick={calculateScore} 
            style={{ width: "100%", padding: "15px", fontSize: "18px", backgroundColor: "#007BFF", color: "white", border: "none", borderRadius: "8px", cursor: "pointer", fontWeight: "bold" }}
          >
            Nộp Bài Chấm Điểm!
          </button>
        ) : (
          <button 
            onClick={() => { setIsSubmitted(false); setAnswers({}); setScore(0); window.scrollTo({ top: 0, behavior: "smooth" }); }} 
            style={{ width: "100%", padding: "15px", fontSize: "18px", backgroundColor: "#333", color: "white", border: "none", borderRadius: "8px", cursor: "pointer", fontWeight: "bold" }}
          >
            Làm Lại Lần Nữa Cho Nhớ!
          </button>
        )}
      </div>
    </div>
  );
}